require('../modules/es6.function.bind');
require('../modules/es6.function.name');
require('../modules/es6.function.has-instance');
module.exports = require('../modules/_core').Function;



//////////////////
// WEBPACK FOOTER
// F:/Agent/vsts-agent1/_work/76/s/CIA.ClientSide/~/core-js/es6/function.js
// module id = ../../../../core-js/es6/function.js
// module chunks = 1